module.exports = __webpack_public_path__ + "aa42c093ea9640a805d793b79b72cc78.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/home-gray.png
 ** module id = 1393
 ** module chunks = 0
 **/